import React from 'react';
import '@apollo/client';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { useClickTracker } from '@shared-ui/clickstream-analytics-context';
import { useDialog } from '@shared-ui/dialog-context';
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

var fragment$2 = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "EnrichedMessageFragment" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "LodgingEnrichedMessage" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "value" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "state" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }], "loc": { "start": 0, "end": 103, "source": { "body": "\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var stateToUitkTextWeight = {
    STRONG: 'bold'
};
var ENRICHED_STYLES = [
    {
        size: 200
    },
    {
        size: 200
    },
    {
        size: 300
    },
    {
        size: 200
    }
];
var EnrichedMessage = function (_a) {
    var _b = _a.data, value = _b.value, state = _b.state, textAlign = _a.textAlign, experimentStyleVariant = _a.experimentStyleVariant;
    return (React.createElement(UitkText, { size: ENRICHED_STYLES[experimentStyleVariant !== null && experimentStyleVariant !== void 0 ? experimentStyleVariant : 0].size, weight: (state && stateToUitkTextWeight[state]) || undefined, align: textAlign }, value));
};
EnrichedMessage.fragment = fragment$2;
EnrichedMessage.fragment.__typename = 'LodgingEnrichedMessage';
EnrichedMessage.displayName = 'EnrichedMessage';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}

var PriceDisclaimer = function (_a) {
    var _b;
    var disclaimer = _a.disclaimer, textAlign = _a.textAlign, children = _a.children, type = _a.type;
    var content = disclaimer.content, primaryUIButton = disclaimer.primaryUIButton;
    var dialogKey = React.useMemo(function () { return Math.random().toString(36).substr(2, 5); }, []);
    var dialogId = type + "-price-disclaimer-" + dialogKey;
    var _c = __read(useDialog(dialogId), 3), isDialogOpen = _c[0], dialogActions = _c[1], DialogComponent = _c[2];
    var trackClick = useClickTracker();
    var handleMoreInfoClick = React.useCallback(function () {
        dialogActions.openDialog();
    }, [dialogActions]);
    return (React.createElement(React.Fragment, null,
        React.createElement(UitkMoreInfoTrigger, { onClick: handleMoreInfoClick, onClickCapture: function () { return trackClick('.Price.DisclaimerDialog', 'Price Disclaimer Dialog'); }, "data-stid": "disclaimer-dialog-link" },
            React.createElement("button", { type: "button" },
                React.createElement(UitkLayoutFlex, { direction: textAlign === 'left' ? 'row-reverse' : 'row' },
                    React.createElement(UitkLayoutFlexItem, null,
                        React.createElement(UitkIcon, { name: "info_outline", size: UitkIconSize.SMALL })),
                    React.createElement(UitkLayoutFlexItem, null, children)))),
        React.createElement(DialogComponent, null,
            React.createElement(UitkDialog, { returnFocusOnClose: true, dialogShow: isDialogOpen },
                React.createElement(UitkDialogContent, null, content),
                React.createElement(UitkDialogFooter, { buttonOne: {
                        onClick: dialogActions.closeDialog,
                        text: (_b = primaryUIButton === null || primaryUIButton === void 0 ? void 0 : primaryUIButton.primary) !== null && _b !== void 0 ? _b : '',
                        type: 'tertiary'
                    } })))));
};

var fragment$1 = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "PriceMessageFragment" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "DisplayPrice" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "role" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "price" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "formatted" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "accessibilityLabel" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "disclaimer" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "content" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "primaryUIButton" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "accessibility" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "primary" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }], "loc": { "start": 0, "end": 245, "source": { "body": "\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var LEAD_STYLES = [
    {
        size: 600,
        weight: 'bold'
    },
    {
        size: 600,
        weight: 'medium'
    },
    {
        size: 500,
        weight: 'medium'
    },
    {
        size: 600,
        weight: 'bold'
    }
];
var FallbackPrice = function (_a) {
    var _b = _a.price, formatted = _b.formatted, accessibilityLabel = _b.accessibilityLabel;
    return (React.createElement(UitkSpacing, null,
        React.createElement("div", null,
            React.createElement(UitkText, { className: "is-visually-hidden" }, accessibilityLabel || formatted),
            React.createElement("span", { "aria-hidden": "true" },
                React.createElement(UitkText, null, formatted)))));
};
var LeadPrice = function (_a) {
    var _b = _a.price, formatted = _b.formatted, accessibilityLabel = _b.accessibilityLabel, style = _a.style;
    return (React.createElement(UitkSpacing, { padding: { block: 'half' } },
        React.createElement("div", null,
            React.createElement(UitkText, { className: "is-visually-hidden" }, accessibilityLabel || formatted),
            React.createElement("span", { "aria-hidden": "true" },
                React.createElement(UitkText, __assign({}, style, { theme: "emphasis" }), formatted)))));
};
var StrikeOutPrice = function (_a) {
    var _b = _a.price, formatted = _b.formatted, accessibilityLabel = _b.accessibilityLabel, disclaimer = _a.disclaimer, textAlign = _a.textAlign;
    var strikeOutText = (React.createElement(UitkSpacing, { padding: { inline: 'half' } },
        React.createElement("div", null,
            React.createElement("del", null,
                React.createElement(UitkText, { className: "is-visually-hidden" }, accessibilityLabel || formatted),
                React.createElement("span", { "aria-hidden": "true" },
                    React.createElement(UitkText, { size: 300 }, formatted))))));
    if (disclaimer) {
        return (React.createElement(PriceDisclaimer, { disclaimer: disclaimer, textAlign: textAlign, type: "STRIKEOUT" }, strikeOutText));
    }
    return strikeOutText;
};
var InformativePrice = function (_a) {
    var _b = _a.price, formatted = _b.formatted, accessibilityLabel = _b.accessibilityLabel, disclaimer = _a.disclaimer;
    var informativeText = (React.createElement(UitkSpacing, { padding: { inline: 'half' } },
        React.createElement("div", null,
            React.createElement(UitkText, { className: "is-visually-hidden" }, accessibilityLabel || formatted),
            React.createElement("span", { "aria-hidden": "true" },
                React.createElement(UitkText, { size: 200 }, formatted)))));
    if (disclaimer) {
        return (React.createElement(PriceDisclaimer, { disclaimer: disclaimer, textAlign: "left", type: "INFORMATIVE" }, informativeText));
    }
    return informativeText;
};
var PriceMessage = function (_a) {
    var data = _a.data, textAlign = _a.textAlign, experimentStyleVariant = _a.experimentStyleVariant;
    var role = data.role;
    switch (role) {
        case 'LEAD':
            return React.createElement(LeadPrice, __assign({}, data, { style: LEAD_STYLES[experimentStyleVariant !== null && experimentStyleVariant !== void 0 ? experimentStyleVariant : 0] }));
        case 'STRIKEOUT':
            return React.createElement(StrikeOutPrice, __assign({}, data, { textAlign: textAlign }));
        case 'INFORMATIVE':
            return React.createElement(InformativePrice, __assign({}, data));
        default:
            return React.createElement(FallbackPrice, __assign({}, data));
    }
};
PriceMessage.fragment = fragment$1;
PriceMessage.fragment.__typename = 'DisplayPrice';
PriceMessage.displayName = 'PriceMessage';
StrikeOutPrice.displayName = 'StrikeOutPrice';
LeadPrice.displayName = 'LeadPrice';
FallbackPrice.displayName = 'FallbackPrice';

var fragment = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "PriceSummaryFragment" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "PropertyPrice" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "displayMessages" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "lineItems" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "PriceMessageFragment" }, "directives": [] }, { "kind": "FragmentSpread", "name": { "kind": "Name", "value": "EnrichedMessageFragment" }, "directives": [] }] } }] } }] } }].concat(PriceMessage.fragment.definitions, EnrichedMessage.fragment.definitions), "loc": { "start": 0, "end": 184, "source": { "body": "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n  }\n\n  \n  \n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
var validLinesItems = [
    PriceMessage,
    EnrichedMessage
];
var MessageLine = function (_a) {
    var _b;
    var flexAlignment = _a.flexAlignment, index = _a.index, displayMessage = _a.displayMessage, experimentStyleVariant = _a.experimentStyleVariant;
    return (React.createElement(UitkLayoutFlex, { space: "one", justifyContent: flexAlignment, direction: "row", alignItems: "center", wrap: "wrap", dataTestId: "price-summary-message-line" }, (_b = displayMessage === null || displayMessage === void 0 ? void 0 : displayMessage.lineItems) === null || _b === void 0 ? void 0 : _b.map(function (lineItem, lineItemIndex) {
        var __typename = (lineItem || {}).__typename;
        var LineItem = validLinesItems.find(function (component) { return component.fragment.__typename === __typename; });
        if (!LineItem) {
            return null;
        }
        return (React.createElement(LineItem, { key: "attr-" + index + "-" + lineItemIndex, data: lineItem, textAlign: flexAlignment === 'end' ? 'right' : 'left', experimentStyleVariant: experimentStyleVariant }));
    })));
};
var PriceSummary = function (_a) {
    var data = _a.data, _b = _a.flexAlignment, flexAlignment = _b === void 0 ? 'end' : _b;
    var displayMessages = data.displayMessages;
    if (!(displayMessages === null || displayMessages === void 0 ? void 0 : displayMessages.length)) {
        return null;
    }
    return (React.createElement(UitkLayoutFlex, { direction: "column" },
        React.createElement(Experiment, { name: "Nightly_PoS_test_total_as_lead_price" },
            React.createElement(ExperimentControl, null, displayMessages.map(function (displayMessage, index) { return (React.createElement(MessageLine, { key: "attr-" + index, index: index, flexAlignment: flexAlignment, displayMessage: displayMessage, experimentStyleVariant: 0 })); })),
            React.createElement(ExperimentVariant, { bucket: 1 }, displayMessages.map(function (displayMessage, index) { return (React.createElement(MessageLine, { key: "attr-" + index, index: index, flexAlignment: flexAlignment, displayMessage: displayMessage, experimentStyleVariant: 1 })); })),
            React.createElement(ExperimentVariant, { bucket: 2 }, displayMessages.map(function (displayMessage, index) { return (React.createElement(MessageLine, { key: "attr-" + index, index: index, flexAlignment: flexAlignment, displayMessage: displayMessage, experimentStyleVariant: 2 })); })),
            React.createElement(ExperimentVariant, { bucket: 3 }, displayMessages.map(function (displayMessage, index) { return (React.createElement(MessageLine, { key: "attr-" + index, index: index, flexAlignment: flexAlignment, displayMessage: displayMessage, experimentStyleVariant: 3 })); })))));
};
PriceSummary.fragment = fragment;
PriceSummary.displayName = 'PriceSummary';
MessageLine.displayName = 'MessageLine';

export { PriceSummary };
